import { FormProvider, useForm } from 'react-hook-form';
import { vehicle as rules } from 'further-ui/validations';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { PropsWithChildren } from 'react';
import useVehicle from 'hooks/lp/data/vehicle/useVehicle';
import { createEmptyFeeTemplate } from './helpers';

const formSchema = rules.UpdateFeeSettings;

export type InferredFeeSettingsFormType = z.infer<typeof formSchema>;

type Props = {
  vehicleId: string;
};

const FormWrapper: React.FC<PropsWithChildren<Props>> = ({
  children,
  vehicleId,
}) => {
  const { vehicle } = useVehicle(vehicleId);
  const lpFeeTemplates = vehicle?.lpFeeTemplates.map((feeTemplate) => ({
    ...feeTemplate,
  })) as InferredFeeSettingsFormType['lpFeeTemplates'];

  const formMethods = useForm<InferredFeeSettingsFormType>({
    shouldFocusError: true,
    resolver: zodResolver(formSchema),
    defaultValues: {
      lpFeeTemplates: lpFeeTemplates?.length
        ? lpFeeTemplates
        : [createEmptyFeeTemplate(true)],
    },
    criteriaMode: 'all',
    mode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
